import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-195d6ff1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "users"
};
var _hoisted_2 = {
  class: "details flex-fill"
};
var _hoisted_3 = {
  class: "name"
};
var _hoisted_4 = {
  class: "joined-on"
};
var _hoisted_5 = {
  class: "actions"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode("Try again");

var _hoisted_7 = {
  key: 1,
  class: "users"
};
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import Avatar from "@/components/users/Avatar.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    users: {
      default: function _default() {
        return [];
      }
    },
    ownerId: null,
    loader: null,
    error: {
      default: "The requested data is currently inaccessible."
    }
  },
  emits: ["retry"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var userStore = useUserStore();
    var LoaderState = LoaderStateEnum;
    return function (_ctx, _cache) {
      var _component_n_empty = _resolveComponent("n-empty");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      return __props.loader !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.loader !== _unref(LoaderState).Failed ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.users.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.users, function (user) {
        var _unref$user;

        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["user-item d-flex flex-row align-items-center", {
            'is-owner': user.id === __props.ownerId,
            'is-user': _unref(userStore).authenticated && user.id === ((_unref$user = _unref(userStore).user) === null || _unref$user === void 0 ? void 0 : _unref$user.id)
          }]),
          key: user.id
        }, [_createVNode(Avatar, {
          user: user,
          class: "me-3"
        }, null, 8, ["user"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("strong", null, _toDisplayString(user.userName), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("small", null, [_renderSlot(_ctx.$slots, "notice", {
          user: user
        })])])]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "actions", {
          user: user
        })])], 2);
      }), 128))])) : _renderSlot(_ctx.$slots, "empty", {
        key: 1
      }, function () {
        return [_createVNode(_component_n_empty, {
          description: "There isn't any user yet."
        })];
      })], 64)) : (_openBlock(), _createBlock(_component_n_result, {
        key: 1,
        status: "error",
        title: "Error",
        description: __props.error
      }, {
        footer: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return emit('retry');
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_6];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["description"]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, function (n) {
        return _createVNode(_component_n_skeleton, {
          class: "skeleton-item user-item",
          sharp: false,
          key: n
        });
      }), 64))]));
    };
  }
});